import React from 'react'

import { translate } from 'parking-react-common'

import { externalSessions } from '../redux'
import ExternalSessionsList from '../components/ExternalSessionsList'

const ExternalSessionsContainer = ({ t }) => (
    <ExternalSessionsList
        title={ t('External Sessions') }
        dataSelector={ externalSessions.getAll }
        showParkingLot
    />
)

export default translate()(ExternalSessionsContainer)
